let activeHomepageLoadingController;

function trackHomepageLoading() {
  const loading = document.getElementById('homepage-loading');
  if (!loading?.open) return;

  activeHomepageLoadingController?.abort();
  const controller = new AbortController();
  activeHomepageLoadingController = controller;
  let closeTimeout;
  let animationFrame;
  controller.signal.addEventListener('abort', () => {
    clearTimeout(closeTimeout);
    cancelAnimationFrame(animationFrame);
    if (activeHomepageLoadingController === controller) activeHomepageLoadingController = undefined;
  }, { once: true });
  loading.addEventListener('close', () => controller.abort(), { once: true, signal: controller.signal });
  const progress = loading.querySelector('.homepage-loading__progress');
  const media = [...document.querySelectorAll('#header-group img, #MainContent > .shopify-section:first-child img, #MainContent > .shopify-section:first-child video')]
    .filter((element) => {
      const bounds = element.getBoundingClientRect();
      return getComputedStyle(element).visibility === 'visible'
        && bounds.width > 0 && bounds.height > 0
        && bounds.top < window.innerHeight && bounds.bottom > 0
        && bounds.left < window.innerWidth && bounds.right > 0;
    });

  const resources = media.map((element) => new Promise((resolve) => {
    const isVideo = element.tagName === 'VIDEO';
    if (isVideo ? element.readyState >= 2 || element.error : element.complete) {
      resolve();
      return;
    }
    const options = { once: true, signal: controller.signal };
    element.addEventListener(isVideo ? 'loadeddata' : 'load', resolve, options);
    element.addEventListener('error', resolve, options);
  }));
  resources.push(document.fonts.ready);

  let completed = 0;
  resources.forEach((resource) => {
    resource.catch(() => {}).then(() => {
      if (!loading.open || controller.signal.aborted) return;
      completed += 1;
    });
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let displayed = 0;
  let previousTime;
  const updateProgress = (time) => {
    if (!loading.open || controller.signal.aborted) return;
    const target = Math.floor(completed / resources.length * 100);
    // Take about 600ms from 0 to 100, even when resources are cached.
    // Cap each step so returning from a background tab does not skip the count.
    const elapsed = previousTime === undefined ? 0 : Math.min(time - previousTime, 64);
    previousTime = time;
    displayed = reducedMotion ? target : Math.min(target, displayed + elapsed / 6);
    const text = `${Math.floor(displayed)}%`;
    if (progress.textContent !== text) progress.textContent = text;

    if (displayed < 100) {
      animationFrame = requestAnimationFrame(updateProgress);
      return;
    }

    loading.setAttribute('aria-busy', 'false');
    closeTimeout = setTimeout(() => {
      if (!loading.open || controller.signal.aborted) return;
      loading.classList.add('is-closing');
      loading.addEventListener('transitionend', (event) => {
        if (event.target === loading && event.propertyName === 'height') loading.close();
      }, { signal: controller.signal });
      // Also release the page if the transition is interrupted or disabled.
      closeTimeout = setTimeout(() => loading.close(), 700);
    }, reducedMotion ? 0 : 60);
  };
  animationFrame = requestAnimationFrame(updateProgress);
}

trackHomepageLoading();
window.addEventListener('pageshow', (event) => {
  if (event.persisted) trackHomepageLoading();
});
